function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M217.919 53.5888H11.0806C4.97059 53.5888 0 58.5594 0 64.6694V186.557C0 192.667 4.97059 197.637 11.0806 197.637H217.919C224.029 197.637 229 192.667 229 186.557V64.6694C229 58.5594 224.029 53.5888 217.919 53.5888Z",
  fill: "#3F51B5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M125.581 179.169H103.42V197.637H125.581V179.169Z",
  fill: "#407BFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M214.327 168.089V179.169C214.327 181.209 212.673 182.863 210.633 182.863H18.5685C16.5288 182.863 14.875 181.209 14.875 179.169V168.089L36.9352 157.008L125.58 160.702L199.451 157.008L214.327 168.089Z",
  fill: "#61ADE2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.057 173.189C50.4083 160.659 84.7329 161.421 114.601 175.476V42.5081C83.7481 27.9902 48.1405 27.6554 17.0685 41.5035C15.7314 42.0995 14.875 43.4528 14.875 44.9168V169.812C14.875 172.48 17.5911 174.207 20.057 173.189Z",
  fill: "#BDD7E9"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M114.602 175.476C144.469 161.421 178.794 160.659 209.145 173.189C211.611 174.207 214.327 172.48 214.327 169.812V44.9168C214.327 43.4528 213.471 42.0995 212.134 41.5035C181.062 27.6554 145.454 27.9902 114.602 42.5081V175.476V175.476Z",
  fill: "#95C3E3"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M129.376 151.354C127.803 151.354 126.346 150.344 125.852 148.766C125.242 146.82 126.324 144.746 128.268 144.135C132.005 142.961 135.85 141.958 139.699 141.152C141.69 140.734 143.652 142.009 144.07 144.009C144.489 146.006 143.212 147.963 141.213 148.381C137.599 149.139 133.989 150.082 130.483 151.183C130.115 151.298 129.74 151.354 129.376 151.354Z",
  fill: "#868491"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M199.554 151.354C199.189 151.354 198.814 151.298 198.446 151.183C184.509 146.806 170.063 145.167 155.523 146.325C153.46 146.472 151.711 144.967 151.549 142.934C151.39 140.9 152.905 139.121 154.939 138.959C170.456 137.74 185.822 139.475 200.661 144.135C202.605 144.746 203.688 146.82 203.078 148.766C202.583 150.345 201.126 151.354 199.554 151.354Z",
  fill: "#868491"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M199.553 136.537C199.188 136.537 198.813 136.481 198.445 136.365C176.212 129.382 152.716 129.382 130.483 136.365C128.528 136.977 126.457 135.893 125.852 133.949C125.242 132.003 126.324 129.929 128.268 129.318C151.952 121.88 176.977 121.88 200.66 129.318C202.604 129.929 203.687 132.003 203.077 133.949C202.582 135.527 201.125 136.537 199.553 136.537Z",
  fill: "#868491"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M129.376 121.806C127.803 121.806 126.346 120.796 125.852 119.218C125.242 117.272 126.324 115.198 128.268 114.587C141.863 110.32 155.97 108.504 170.181 109.171C172.215 109.269 173.792 110.998 173.694 113.036C173.6 115.078 171.898 116.636 169.827 116.551C156.492 115.922 143.244 117.628 130.482 121.635C130.115 121.75 129.74 121.806 129.376 121.806Z",
  fill: "#868491"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M199.553 121.806C199.189 121.806 198.813 121.75 198.446 121.635C193.779 120.168 188.963 118.992 184.133 118.141C182.124 117.786 180.782 115.871 181.14 113.861C181.493 111.854 183.412 110.51 185.418 110.866C190.561 111.773 195.687 113.025 200.661 114.587C202.605 115.198 203.687 117.272 203.077 119.218C202.583 120.796 201.125 121.806 199.553 121.806Z",
  fill: "#868491"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M199.553 106.988C199.188 106.988 198.813 106.932 198.445 106.817C176.212 99.8338 152.716 99.8338 130.483 106.817C128.528 107.425 126.457 106.343 125.852 104.4C125.242 102.454 126.324 100.38 128.268 99.7692C151.952 92.3318 176.977 92.3318 200.66 99.7692C202.604 100.38 203.687 102.454 203.077 104.4C202.582 105.979 201.125 106.988 199.553 106.988Z",
  fill: "#868491"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M129.376 92.2145C127.803 92.2145 126.346 91.2043 125.852 89.6267C125.242 87.6807 126.324 85.6068 128.268 84.9955C135.699 82.6616 143.389 81.0425 151.133 80.1837C153.188 79.9367 154.989 81.4229 155.212 83.446C155.435 85.4733 153.975 87.3003 151.948 87.5237C144.68 88.3317 137.455 89.852 130.483 92.0432C130.115 92.1582 129.74 92.2145 129.376 92.2145Z",
  fill: "#868491"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M199.553 92.2145C199.189 92.2145 198.814 92.1587 198.446 92.0432C188.018 88.7661 177.19 87.0168 166.257 86.8455C164.216 86.8132 162.589 85.134 162.622 83.0942C162.654 81.0563 164.436 79.3393 166.373 79.4584C178.016 79.6421 189.555 81.5055 200.661 84.995C202.605 85.6063 203.687 87.6802 203.077 89.6263C202.579 91.2043 201.126 92.2145 199.553 92.2145Z",
  fill: "#868491"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M129.376 77.4833C127.803 77.4833 126.346 76.4731 125.852 74.8955C125.242 72.9494 126.324 70.8755 128.268 70.2642C144.362 65.2091 161.019 63.5858 177.799 65.4524C179.826 65.6759 181.287 67.5028 181.063 69.5301C180.84 71.5556 179.051 73.0561 176.984 72.7924C161.243 71.0468 145.592 72.5634 130.482 77.312C130.115 77.4274 129.74 77.4833 129.376 77.4833Z",
  fill: "#868491"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M199.553 77.4833C199.188 77.4833 198.813 77.4274 198.445 77.312C196.101 76.5742 193.695 75.9052 191.289 75.3193C189.309 74.8359 188.093 72.8377 188.577 70.8556C189.06 68.8736 191.044 67.6616 193.042 68.1413C195.6 68.7656 198.161 69.4793 200.66 70.2642C202.604 70.8755 203.687 72.9494 203.077 74.8955C202.582 76.4735 201.125 77.4833 199.553 77.4833Z",
  fill: "#868491"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M129.376 62.6661C127.803 62.6661 126.346 61.6545 125.852 60.0765C125.242 58.1286 126.324 56.0565 128.272 55.4471C130.811 54.6497 133.372 53.9373 135.886 53.3261C137.856 52.8408 139.864 54.0602 140.348 56.0422C140.831 58.0243 139.612 60.0225 137.632 60.504C135.273 61.0774 132.867 61.7464 130.479 62.4948C130.111 62.6098 129.74 62.6661 129.376 62.6661Z",
  fill: "#868491"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M199.552 62.6661C199.188 62.6661 198.813 62.6102 198.445 62.4948C183.332 57.7463 167.689 56.2315 151.944 57.9753C149.902 58.2242 148.088 56.7361 147.864 54.713C147.641 52.6857 149.102 50.8588 151.129 50.6353C167.901 48.7687 184.562 50.392 200.659 55.4471C202.604 56.0584 203.686 58.1323 203.076 60.0783C202.582 61.6559 201.125 62.6661 199.552 62.6661Z",
  fill: "#868491"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M29.6491 151.354C28.0766 151.354 26.6195 150.344 26.125 148.766C25.5156 146.82 26.5973 144.746 28.5415 144.135C32.2784 142.961 36.1234 141.958 39.9721 141.152C41.9666 140.734 43.9256 142.009 44.3439 144.009C44.7622 146.006 43.4856 147.963 41.4869 148.381C37.8728 149.139 34.2623 150.082 30.7562 151.183C30.3883 151.298 30.0134 151.354 29.6491 151.354Z",
  fill: "#B4B6BC"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M99.827 151.354C99.4627 151.354 99.0874 151.298 98.7199 151.183C84.786 146.806 70.3363 145.167 55.7967 146.325C53.7048 146.472 51.984 144.967 51.822 142.934C51.6632 140.9 53.1784 139.121 55.2127 138.959C70.7297 137.74 86.0921 139.475 100.935 144.135C102.879 144.746 103.961 146.82 103.351 148.766C102.857 150.345 101.4 151.354 99.827 151.354Z",
  fill: "#B4B6BC"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M99.8261 136.537C99.4618 136.537 99.0864 136.481 98.7189 136.365C76.4856 129.382 52.9896 129.382 30.7562 136.365C28.794 136.977 26.7307 135.893 26.125 133.949C25.5156 132.003 26.5973 129.929 28.5415 129.318C52.225 121.88 77.2502 121.88 100.934 129.318C102.878 129.929 103.96 132.003 103.35 133.949C102.856 135.527 101.399 136.537 99.8261 136.537Z",
  fill: "#B4B6BC"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M29.6491 121.806C28.0766 121.806 26.6195 120.796 26.125 119.218C25.5156 117.272 26.5973 115.198 28.5415 114.587C42.1361 110.32 56.2537 108.504 70.4545 109.171C72.4887 109.269 74.065 110.998 73.9675 113.036C73.8701 115.078 72.1494 116.636 70.1008 116.551C56.7621 115.922 43.5175 117.628 30.7558 121.635C30.3883 121.75 30.0134 121.806 29.6491 121.806Z",
  fill: "#B4B6BC"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M99.8263 121.806C99.4621 121.806 99.0867 121.75 98.7192 121.635C94.052 120.168 89.2365 118.992 84.4067 118.141C82.3974 117.786 81.0557 115.871 81.4131 113.861C81.7631 111.854 83.6892 110.51 85.6911 110.866C90.8349 111.773 95.9601 113.025 100.934 114.587C102.879 115.198 103.961 117.272 103.351 119.218C102.856 120.796 101.399 121.806 99.8263 121.806Z",
  fill: "#B4B6BC"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M29.6491 106.988C28.0766 106.988 26.6195 105.978 26.125 104.4C25.5156 102.454 26.5973 100.38 28.5415 99.7692C49.5379 93.1776 71.9407 92.4435 93.312 97.6482C95.2959 98.1316 96.5116 100.13 96.0282 102.112C95.5448 104.092 93.536 105.298 91.5664 104.826C71.497 99.9331 50.4682 100.627 30.7562 106.817C30.3883 106.932 30.0134 106.988 29.6491 106.988Z",
  fill: "#B4B6BC"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M29.6491 92.2145C28.0766 92.2145 26.6195 91.2043 26.125 89.6267C25.5156 87.6807 26.5973 85.6068 28.5415 84.9955C35.972 82.6616 43.662 81.0425 51.4059 80.1837C53.4439 79.9367 55.262 81.4229 55.4855 83.446C55.7089 85.4733 54.2481 87.3003 52.2213 87.5237C44.9533 88.3317 37.7283 89.852 30.7562 92.0432C30.3883 92.1582 30.0134 92.2145 29.6491 92.2145Z",
  fill: "#B4B6BC"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M92.4434 90.1563C92.1548 90.1563 91.8589 90.1221 91.5671 90.0515C83.3794 88.057 74.9535 86.9766 66.5308 86.845C64.4892 86.8127 62.8627 85.1335 62.895 83.0937C62.9273 81.0558 64.5216 79.3388 66.6463 79.4579C75.6202 79.6006 84.5909 80.7493 93.3128 82.8735C95.2967 83.3569 96.5123 85.3551 96.0289 87.3372C95.6171 89.0256 94.106 90.1563 92.4434 90.1563Z",
  fill: "#B4B6BC"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M29.6491 77.4833C28.0766 77.4833 26.6195 76.4731 26.125 74.8955C25.5156 72.9494 26.5973 70.8755 28.5415 70.2642C44.6394 65.2091 61.2963 63.5858 78.0724 65.4524C80.0997 65.6759 81.5605 67.5028 81.3366 69.5301C81.1132 71.5556 79.3093 73.0561 77.2571 72.7924C61.5161 71.0468 45.8656 72.5634 30.7558 77.312C30.3883 77.4274 30.0134 77.4833 29.6491 77.4833Z",
  fill: "#B4B6BC"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M29.6491 62.6661C28.0765 62.6661 26.6194 61.6545 26.125 60.0765C25.5155 58.1286 26.5973 56.0565 28.5452 55.4471C31.0845 54.6497 33.6455 53.9373 36.1594 53.3261C38.1253 52.8408 40.1378 54.0602 40.6212 56.0422C41.1046 58.0243 39.8853 60.0225 37.9051 60.504C35.5463 61.0774 33.1404 61.7464 30.7525 62.4948C30.3846 62.6098 30.0134 62.6661 29.6491 62.6661Z",
  fill: "#B4B6BC"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M92.4424 60.6065C92.1538 60.6065 91.8579 60.5723 91.5661 60.5017C78.6567 57.358 65.419 56.5122 52.2173 57.9749C50.19 58.2237 48.3613 56.7394 48.1378 54.7125C47.9143 52.6852 49.3751 50.8583 51.402 50.6349C65.4582 49.0692 79.5653 49.9783 93.3113 53.3238C95.2952 53.8072 96.5108 55.8054 96.0274 57.7874C95.6161 59.4754 94.1049 60.6065 92.4424 60.6065Z",
  fill: "#B4B6BC"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M92.4398 99.7554C92.4403 101.23 94.0839 102.11 95.3111 101.292L103.52 95.819L111.73 101.292C112.957 102.11 114.601 101.23 114.601 99.7554V42.8147C114.601 41.3557 113.75 40.009 112.417 39.4162C106.666 36.8584 100.755 34.8071 94.7515 33.2212C93.5802 32.9118 92.4292 33.8177 92.4297 35.0292L92.4398 99.7554Z",
  fill: "#5D647F"
});

var SvgOpenBook = function SvgOpenBook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 229,
    viewBox: "0 0 229 229",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOpenBook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/open-book.a4dcd485.svg";
export { ForwardRef as ReactComponent };